import styled from "styled-components";

export const Carousel = styled.div`
  position: relative;

  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    height: inherit !important;
  }
  .slick-slide {
    margin-inline: 10px;
  }

  .nextArrow,
  .prevArrow {
    position: absolute;
    top: 50%;
    z-index: 10;
  }

  .prevArrow {
    left: -5%;
  }

  .nextArrow {
    right: -5%;
  }
`;
